import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  LogoutResponse,
  logoutResponseSchema,
} from '../../../common/validations'
import { queryClient } from '../../reactQuery'
import { sleep } from '../../utils'

import { post } from 'api/apiClient'

export const useAPILogout = (
  options?: UseMutationOptions<LogoutResponse, ErrorResponse>
) =>
  useMutation({
    mutationFn: async () => {
      const response = await post(
        API_ENDPOINTS.LOGOUT,
        {},
        logoutResponseSchema
      )

      // "invalidates" react-query query cache
      queryClient.removeQueries()

      localStorage.removeItem('loginDevWarning')

      await sleep(1000)

      return response
    },
    ...options,
  })
